import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
const SchoolInformation = () => {  
  useEffect(() => {
    document.title = 'School Information - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>School Information</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
            <div className="row">
            <div className="col-xl-6">
                <h3>BASIC DETAILS</h3>
                <ul className="mainlist">
                    <li>Name of the Principal- <strong> Fr. Vidya Sagar Madanu</strong></li>
                    <li>Principal’s retirement date- <b>Principal Transferable</b></li>
                    <li>Affiliation Validity- <b>Till March 2027</b></li>
                    <li>Affiliation Status- <b> Affiliation granted up to March 2027</b></li>
                    <li>Name of the Trust/ Society/ Company- <b>Society of Pillar, Punjab Haryana.</b></li>
                    <li>Society Registration Number- <b>00335</b></li>
                    <li>Registration Date- <b>2013</b></li>
                    <li>Registration Validity- <b>Permanent</b></li>
                    <li>NOC Issuing Authority - <b>Directorate of School Education, Haryana</b></li>
                    <li>Upload No Objection Certificate <b>(NOC)</b></li>
                    <li>Upload Non Propriety Charter Affidavit</li>
                </ul>
                <h3>STUDENT DETAILS</h3>
                <div className="table-responsive maintable">
                <table className="table">
                        <tbody>
                            <tr>
                                <th colspan="2">Total number of sections per Class-</th>
                            </tr>
                            <tr className="firsttr" align="center">
                                <th>Class</th>
                                <th>Total No. of Students</th>
                            </tr>
                            <tr>
                                <td>Nursey</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>L.K.G</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>U.K.G</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>I</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <td>II</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <td>III</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <td>IV</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <td>V</td>
                                <td>3</td>
                            </tr>
                            <tr>
                                <td>VI</td>
                                <td>3</td>
                            </tr>
                            <tr>
                                <td>VII</td>
                                <td>4</td>
                            </tr>
                            <tr>
                                <td>VIII</td>
                                <td>4</td>
                            </tr>
                            <tr>
                                <td>IX</td>
                                <td>4</td>
                            </tr>
                            <tr>
                                <td>X</td>
                                <td>4</td>
                            </tr>
                            <tr>
                                <td>XI</td>
                                <td>3</td>
                            </tr>
                            <tr>
                                <td>XII</td>
                                <td>3</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-xl-6">
                <h3>FACULTY DETAILS</h3>
                <ul className="mainlist">
                    <li>Total number of Teachers (All Classes)-<b>58</b></li>
                    <li>Number of PGT’s- <b>11</b></li>
                    <li>Number of TGT’s- <b>25</b></li>
                    <li>Number of PRT’s- <b>17</b></li>
                    <li>Number of NTT’S- <b>3</b></li>
                    <li>Number of PET’s-<b>2</b></li>
                    <li>Other Non Teaching Staff- <b>7</b></li>
                    <li>Number of Training attended by faculty since last year- <b>5</b></li>
                </ul>

                <h3>ACADEMIC DETAILS</h3>
                <ul className="mainlist">
                    <li><strong>Name of all subjects offered for Class 10th - </strong>Hindi, English,
                        Mathematics,
                        Social Science, Science.</li>
                    <li><strong>Name of all subjects offered for Class 12th -</strong>English, Mathematics,
                        Physics,
                        Biology, Chemistry, Economics, Business studies, Accounts, Physical Education, Painting,
                        Hindi,
                        History.</li>
                </ul>
                <h3>LOCATION DETAILS</h3>
                <ul className="mainlist">
                    <li>Name of Nearest Nationalized Bank &amp; Distance from Bank- <b>PNB ( 1KM).</b></li>
                    <li>Name of Nearest Bus Station &amp; Distance from Station- <b>Hisar Bus Stand (8 KM).</b>
                    </li>
                    <li>Name of Nearest Railway Station &amp; Distance from Station- <b>Hisar Junction (10
                            KM).</b>
                    </li>
                    <li>Name of Nearest Airport &amp; Distance from Airport- <b>Hisar International Airport
                            (6km)</b>
                    </li>
                    <li>Name of Nearest Hospital &amp; distance from Hospital- <b>Civil Hospital (6 KM).</b>
                    </li>
                    <li>Name of Nearest Police Station &amp; distance from Police Station- <b>Hisar Sadar Thana
                            (4
                            KM).</b></li>
                    <li>Name of Nearest Metro Station &amp; distance from Metro Station- <b>No</b></li>
                </ul>

                <h3>OTHER VITAL DETAILS</h3>
                <ul className="mainlist">
                    <li> Pass % of last 3 years for class 10 (for Schools affiliated up to Secondary
                        Level)-<b>100%</b>
                    </li>
                    <li>Details of Emergency Contact Person- Mrs. Veerangana Sharma (PGT English, Coordinator,
                        9466116557).</li>
                    <li>Upload Staff Statement of School (Teaching &amp; Non-Teaching)</li>
                </ul>

            </div>
            <div className="col-xl-6">
                <h3>INFRASTRUCTURE DETAILS</h3>
                <ul className="mainlist">
                    <li>Number of Building Blocks of School- <b>2</b></li>
                    <li>Number of Rooms- <b>40</b></li>
                    <li>Number of Restrooms- <b>4 Common Staff Rooms</b></li>
                    <li>Number of Toilets-<b>Staff-4, Girls-10, Boys-10</b></li>
                    <li>Number of Libraries-<b>1</b></li>
                    <li>Number of Laboratries-<b>5</b></li>
                    <li>Number of Lifts/Elevators-<b>No</b></li>
                    <li>Number of Smart Classes-<b>All Classes</b></li>
                    <li>Number of Computers in Computer lab-<b>33</b></li>
                    <li>Number of Canteens (Staff &amp; Student)- <b>1 Common</b></li>
                    <li>Hostel Facility-<b>No</b></li>
                    <li>Gymnasium Facility- <b>No</b></li>
                </ul>
            </div>
            <div className="col-xl-6">
                <ul className="mainlist">
                    <li>Swimming Pool Facility- <b>No</b></li>
                    <li>Wi Fi Facility- <b>No</b></li>
                    <li>Web server Facility- <b>Yes</b></li>
                    <li>Availability of Boundary walls- <b>Yes</b></li>
                    <li>Availability of Strong Room- <b>Yes</b></li>
                    <li>Availability of Clinic- <b>No</b></li>
                    <li>Availability of Fire Extinguishers- <b>Yes</b></li>
                    <li>Availability of Water Sprinklers- <b>Yes</b></li>
                    <li>Upload Building Safety Certificate</li>
                    <li>Upload Transport Safety Certificate</li>
                </ul>
            </div>
        </div>        
            </div>
           </section>
           <Footer/>
        </>
    );
}

export default SchoolInformation;
